import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import styled from 'styled-components'
import Paypal from './Paypal'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import CustomImage from '../Utils/CustomImage'
import moment from 'moment'
import {
  Title,
  Subtitle,
  ActionButtons,
  Input,
  LoadingButton,
} from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const CenterSmallMargin = styled(Center)`
  margin-top: 30px;
`

const PaymentButton = styled(ActionButtons)`
  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }
`

const PaymentLoadingButton = styled(LoadingButton)`
  @media screen and (max-width: 799px) {
    width: -webkit-fill-available;
  }
`

const BackButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 10px 0 0;
  }

  @media screen and (min-width: 769px) {
    max-width: 150px;
  }
`

const PriceChoiceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 30px;
  margin: 40px 0 0;
  width: 100%;
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  align-items: top;
  justify-content: left;
  margin-top: 10px;

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBoxHeaderBadgeContainer = styled.div`
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  box-shadow: 4px 4px 5px -2px #b5b5b5;
  height: 60px;
  width: 60px;
  position: absolute;
  top: -13px;
  right: -19px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  text-transform: capitalize;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 126%;
  margin: 14px 0 0;
`

const PriceBox = styled.div`
  box-shadow: ${(props) => (props.shadow ? '0 5px 9px -2px #b5b5b5;' : 'none')};
  border: 1px solid #a5a5a5;
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
  min-width: 230px;
  flex-basis: 33.33%;
`

const PriceBoxHeader = styled.div`
  background-color: #4350b0;
  padding: 6px;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 30px auto 34px;
  width: 170px;
  position: relative;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const PriceSubtitleStrike = styled(Subtitle)`
  color: #ff0000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  position: absolute;
  top: -20px;
  font-size: 20px;
  text-decoration: line-through;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: #6a6a6a;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 0 0 2px;
  text-transform: uppercase;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  width: 183px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  span {
    color: #ff0000;
    font-weight: 700;
    text-decoration: line-through;
  }

  @media (max-width: 799px) {
    font-size: 17px !important;
    width: 210px;
  }
`

const InfoBox = styled.div`
  flex-basis: 66.66%;

  @media (max-width: 799px) {
    text-align: center;
  }
`

const PriceChoiceTitle = styled(Subtitle)`
  @media (max-width: 799px) {
    font-size: 22px !important;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  margin: 24px 20px 30px 0;

  span {
    text-transform: capitalize;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const FlexRowDiscount = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
`

const DiscountSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 24px 20px 8px 0;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const DiscountInput = styled(Input)`
  margin: 0 0 10px 0;
  max-width: 417px;
`

const DiscountButton = styled(ActionButtons)`
  background-color: #0171d5;
  padding: 8px 30px;
`

const DiscountLoadingButton = styled(LoadingButton)`
  background-color: #0171d5;
  padding: 13px 30px;
`

const DiscountMessageSubtitle = styled(Subtitle)`
  color: #0000ff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 5px 20px 8px 0;

  span {
    color: #ff0000;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const DiscountErrorMessageSubtitle = styled(DiscountMessageSubtitle)`
  color: #ff0000;
`

const FlexRowButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 20px;
  font-size: 16px;

  @media (max-width: 1099px) {
    display: none;
  }
`

const FlexRowButtonsBottom = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 60px;
  font-size: 16px;

  @media (max-width: 799px) {
    flex-direction: column-reverse;
    margin-top: 30px;
  }

  @media (min-width: 1100px) {
    display: none;
  }
`

const FlexRowTrust = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const Sections = styled.div`
  padding: 74px 5vw 30px 5vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  ${(props) => props.last && 'padding: 74px 5vw 130px 5vw;'}

  @media only screen and (max-width: 980px) {
    padding: 32px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 0 30px 0;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }
`

const SafetySection = styled(Sections)`
  margin: 20px 0 0;
  padding: 34px 0 30px 0;
`

const SectionText = styled.div`
  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 6vw auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const TrustSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;

  @media only screen and (max-width: 799px) {
    margin: 0 0 15px 0;
  }
`

const TrustParagraph = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;

  @media only screen and (max-width: 799px) {
    margin: 0 0 50px 0;
  }
`

const ChoosePaymentOption = ({
  dCode,
  data,
  onBack,
  onUpdate,
  isCopied,
  setShowPopup,
  setClickedFeeLink,
  actionRef,
}) => {
  const [membershipFee, setMembershipFee] = useState('47.90')
  const [discountMembershipFee, setDiscountMembershipFee] = useState('47.90')
  const [subscriptionType, setSubscriptionType] = useState('annual')
  const [currencySign, setCurrencySign] = useState('')
  const [loading, setLoading] = useState(false)
  const [checkout, setCheckout] = useState(false)
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [displayChoice, setDisplayChoice] = useState(0)
  const [discounted, setDiscounted] = useState(false)
  const [discountCode, setDiscountCode] = useState('')
  const [discountAmount, setDiscountAmount] = useState('')
  const [discountMonthlyAmount, setDiscountMonthlyAmount] = useState('')
  const [discountType, setDiscountType] = useState('')
  const [discountMessage, setDiscountMessage] = useState('')
  const [discountErrorMessage, setDiscountErrorMessage] = useState('')
  const [discountLoading, setDiscountLoading] = useState(false)
  const [subscriptionDisplay, setSubscriptionDisplay] = useState([])
  const [subscriptionDisplayLong, setSubscriptionDisplayLong] = useState([])
  const [monthlyBreakdown, setMonthlyBreakdown] = useState([
    '6.63',
    '4.98',
    '3.99',
  ])
  const [monthlyDivisor, setMonthlyDivisor] = useState([3, 6, 12])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'choose-membership-fee-page-loaded',
      data.auth.user.id + ' - choose membership fee - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          if (pageValue === 'profile-pay') {
            const subsDisplayShort = [pageText[25], pageText[28], pageText[33]]
            const subsDisplayLong = [pageText[44], pageText[45], pageText[46]]
            setSubscriptionDisplay(subsDisplayShort)
            setSubscriptionDisplayLong(subsDisplayLong)
          }

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    getCurrency()

    if (
      data.auth.user.membershipFee !== null &&
      data.auth.user.membershipFee !== undefined &&
      data.auth.user.subscriptionType !== null &&
      data.auth.user.subscriptionType !== undefined
    ) {
      setSubscriptionType(data.auth.user.subscriptionType)
      setMembershipFee(data.auth.user.membershipFee)
      switch (data.auth.user.subscriptionType) {
        case 'quarterly':
          setDisplayChoice(0)
          break
        case 'semi-annual':
          setDisplayChoice(1)
          break
        case 'annual':
          setDisplayChoice(2)
          break
      }
    }

    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  useEffect(() => {
    console.log('vouchcode choose showing: ' + data.auth.user.voucherCode)
    if (data.auth.user.voucherCode === null) {
      setClickedFeeLink(true)
    }
  }, [data.auth.user.voucherCode])

  useEffect(() => {
    // scroll into view when back button
    setTimeout(function () {
      scrollIntoView(actionRef)
    }, 1000)
  }, [])

  useEffect(() => {
    // scroll into view coming from dashboard
    setTimeout(function () {
      scrollIntoView(actionRef)
    }, 1000)

    console.log('check code ' + dCode)
    console.log('isCopied ' + isCopied)
    if (isCopied === true) {
      setDiscountCode(dCode)
      setDiscountMessage('<span>' + pageText[55] + '</span>')
    }
  }, [isCopied, dCode, pageText])

  const handleUpdateCode = (e) => {
    setDiscountLoading(false)
    setDiscountMessage('')
    setDiscountErrorMessage('')
    setDiscountCode(e)
  }

  const handleApplyDiscount = () => {
    setDiscountErrorMessage('')
    if (!data.auth.user.discountType) {
      if (discountCode) {
        setDiscountLoading(true)
        axios
          .get(`api/discount-voucher/${discountCode}`)
          .then((response) => {
            if (Object.keys(response.data).length > 0) {
              if (
                moment() >= moment(response.data.startDate) &&
                moment() <= moment(response.data.endDate).add(1, 'days')
              ) {
                setDiscounted(true)
                setDiscountAmount(response.data.discountAmount)
                setDiscountType(response.data.discountUnit)

                let discountedFeeCalculated = 0.0

                if (response.data.discountUnit === 'PER') {
                  discountedFeeCalculated = Math.round(
                    membershipFee -
                      membershipFee * (response.data.discountAmount / 100)
                  ).toFixed(2)

                  setDiscountMembershipFee(discountedFeeCalculated)
                  setDiscountMonthlyAmount(
                    (
                      (membershipFee -
                        membershipFee * (response.data.discountAmount / 100)) /
                      monthlyDivisor[displayChoice]
                    ).toFixed(2)
                  )
                  setDiscountMessage(
                    pageText[48] +
                      ' <span>' +
                      discountCode +
                      '</span> ' +
                      pageText[49] +
                      ' <span>' +
                      response.data.discountAmount +
                      '%</span>.'
                  )
                } else {
                  discountedFeeCalculated = Math.round(
                    membershipFee - response.data.discountAmount
                  ).toFixed(2)

                  setDiscountMembershipFee(discountedFeeCalculated)
                  setDiscountMonthlyAmount(
                    (
                      (membershipFee - response.data.discountAmount) /
                      monthlyDivisor[displayChoice]
                    ).toFixed(2)
                  )
                  setDiscountMessage(
                    pageText[48] +
                      ' <span>' +
                      discountCode +
                      '</span> ' +
                      pageText[49] +
                      ' <span>' +
                      currencyValue +
                      response.data.discountAmount +
                      '</span>.'
                  )
                }
                /*
                  Discount applied
                  so remove the popup && persist in db
                  UPDATE membershipfee with the discount calculated
                */

                const userData = {
                  membershipFee: discountedFeeCalculated,
                  discount: response.data.discountAmount,
                  discountType: response.data.discountUnit,
                  voucherCode: discountCode,
                }
                data.auth.updateUser(userData).then(() => {
                  removePopUpDiscount()
                })
              } else {
                setDiscountErrorMessage(pageText[50])
                setDiscounted(false)
              }
            } else {
              setDiscountErrorMessage(pageText[50])
              setDiscounted(false)
            }
          })
          .catch((err) => {
            console.log('Error getting discount code: ', err)
            setDiscounted(false)
          })
          .finally(() => {
            setDiscountLoading(false)
          })
      } else {
        setDiscountErrorMessage(pageText[51])
        setDiscounted(false)
        setDiscountLoading(false)
      }
    }
  }

  const removePopUpDiscount = () => {
    setShowPopup(false)
    setClickedFeeLink(false)
  }

  /**
   *
   * PAYPAL
   * */

  const handleChooePaypal = () => {
    gaEvents.eventGeneric(
      'button_click',
      'paypal-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Paypal'
    )
    // redirect to Paypal
    setCheckout(true)
  }

  /**
   *
   * PAY BY CARD
   * */

  const handleSubmit = () => {
    console.log('submit ' + discountCode)
    gaEvents.eventGeneric(
      'button_click',
      'stripe-chosen',
      data.auth.user.id + ' - choose membership fee - button - choose Stripe'
    )
    setLoading(true)
    if (discounted) {
      setTimeout(function () {
        onUpdate() // redirect to paybyCard
      }, 1000)
    } else {
      console.log('nothing ' + discountCode)
      setTimeout(function () {
        onUpdate()
        setLoading(false)
      }, 1000)
    }
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        {checkout ? (
          <div>
            <div>
              <Paypal
                actionRef={actionRef}
                user={data.auth.user}
                subscriptionType={subscriptionType}
                membershipFee={
                  discounted ? discountMembershipFee : membershipFee
                }
                currencySign={data.auth.user.currencyValue}
              />
            </div>

            <div className="text-center">
              <BackButton
                type="submit"
                padding="10px 40px"
                margin="15px 0 20px 12px"
                onClick={(e) => {
                  setCheckout(false)
                }}
              >
                {pageText[10]}
              </BackButton>
            </div>
          </div>
        ) : (
          <ContainerBox>
            <form
              method="POST"
              action="/"
              name="myForm"
              aria-label="Add Profile"
              onSubmit={(event) => {
                event.preventDefault()
                return false
              }}
              style={{ marginTop: 0 }}
            >
              <input
                type="hidden"
                name="csrf-token"
                value={window.Laravel.csrfToken}
              />

              <CenterSmallMargin>
                <img
                  src="/images/icons/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/icons/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </CenterSmallMargin>

              <PriceChoiceBox>
                <FlexRowPrice>
                  <PriceBoxHeaderBadgeContainer>
                    <PriceBoxHeaderBadge>
                      {' '}
                      <PriceHeaderBadgeSubtitle
                        center
                        size="28px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[47]}`,
                        }}
                      />
                    </PriceBoxHeaderBadge>
                    <PriceBox>
                      <PriceBoxHeader>
                        {' '}
                        <PriceHeaderSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${subscriptionType}`,
                          }}
                        />
                      </PriceBoxHeader>
                      <PriceBoxPrice>
                        <PriceContainer>
                          {discounted ? (
                            <>
                              <PriceSubtitleStrike
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                }}
                              />
                              <CurrencySubtitle
                                center
                                size="16px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}`,
                                }}
                              />
                              <PriceSubtitle
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${(Math.round(discountMembershipFee * 100) / 100).toFixed(2)}`,
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <CurrencySubtitle
                                center
                                size="16px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}`,
                                }}
                              />
                              <PriceSubtitle
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                                }}
                              />
                            </>
                          )}

                          <PriceDurationSubtitle
                            center
                            size="13px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `${subscriptionDisplay[displayChoice]}`,
                            }}
                          />
                        </PriceContainer>
                      </PriceBoxPrice>
                      <PriceBoxInfo>
                        {' '}
                        {discounted ? (
                          <PriceInfoSubtitle
                            center
                            size="15px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `<b><span>${currencySign}${monthlyBreakdown[displayChoice]}</span></b> <b>${currencySign}${discountMonthlyAmount}</b> ${pageText[35]} ${subscriptionDisplayLong[displayChoice]}. ${pageText[36]}.`,
                            }}
                          />
                        ) : (
                          <PriceInfoSubtitle
                            center
                            size="15px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `<b>${currencySign}${monthlyBreakdown[displayChoice]}</b> ${pageText[35]} ${subscriptionDisplayLong[displayChoice]}. ${pageText[36]}.`,
                            }}
                          />
                        )}
                      </PriceBoxInfo>
                    </PriceBox>
                  </PriceBoxHeaderBadgeContainer>

                  <InfoBox>
                    {' '}
                    <PriceChoiceTitle size="22px" bold margin="6px 0 10px 1%">
                      {pageText[43]}
                    </PriceChoiceTitle>
                    {/*
                    <PriceChoiceSubtitle
                      size="16px"
                      margin="0 0 10px 1%"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[37]} <span>${subscriptionType}</span> ${pageText[38]} ${currencySign}${(Math.round(membershipFee * 100) / 100).toFixed(2)} ${subscriptionDisplayLong[displayChoice]}. ${pageText[39]} ${currencySign}${monthlyBreakdown[displayChoice]} ${pageText[40]}.`,
                      }}
                    />
                    */}
                    <PriceChoiceSubtitle
                      size="16px"
                      margin="0 0 10px 1%"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[41]}`,
                      }}
                    />
                    <DiscountSubtitle
                      size="16px"
                      margin="0 0 6px 0px"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[52]}:`,
                      }}
                    />
                    <FlexRowDiscount>
                      {' '}
                      <DiscountInput
                        id="discountcode"
                        type="text"
                        name="discountcode"
                        value={discountCode}
                        placeholder={pageText[54]}
                        onChange={(e) => handleUpdateCode(e.target.value)}
                      />
                      {discountLoading ? (
                        <DiscountLoadingButton
                          padding="10px 30px"
                          onClick={() => {
                            handleApplyDiscount()
                          }}
                        ></DiscountLoadingButton>
                      ) : (
                        <DiscountButton
                          padding="10px 30px"
                          onClick={() => {
                            handleApplyDiscount()
                          }}
                        >
                          {pageText[53]}
                        </DiscountButton>
                      )}
                    </FlexRowDiscount>
                    {discountMessage && (
                      <DiscountMessageSubtitle
                        size="16px"
                        dangerouslySetInnerHTML={{
                          __html: `${discountMessage}`,
                        }}
                      />
                    )}
                    {discountErrorMessage && (
                      <DiscountErrorMessageSubtitle
                        size="16px"
                        dangerouslySetInnerHTML={{
                          __html: `${discountErrorMessage}`,
                        }}
                      />
                    )}
                    <FlexRowButtons>
                      <PaymentButton
                        border="#000"
                        color="#000"
                        padding="9px 30px"
                        background="#FFF"
                        onClick={() => {
                          onBack()
                        }}
                      >
                        {pageText[42]}
                      </PaymentButton>
                      {loading ? (
                        <PaymentLoadingButton padding="11px 35px 11px 43px">
                          {pageText[6] + ' ' + pageText[7]}
                        </PaymentLoadingButton>
                      ) : (
                        <PaymentButton
                          padding="10px 30px"
                          onClick={() => {
                            handleSubmit()
                          }}
                        >
                          <img src="/images/icons/card.svg" />{' '}
                          {pageText[6] + ' ' + pageText[7]}
                        </PaymentButton>
                      )}

                      <PaymentButton
                        blackText
                        padding="11px 30px"
                        background="#FCBB32"
                        onClick={() => {
                          handleChooePaypal()
                        }}
                      >
                        {pageText[6] + ' by'}
                        <img src="/images/icons/paypal.svg" />
                      </PaymentButton>
                    </FlexRowButtons>
                  </InfoBox>
                </FlexRowPrice>
                <FlexRowButtonsBottom>
                  <PaymentButton
                    border="#000"
                    color="#000"
                    padding="9px 30px"
                    background="#FFF"
                    onClick={() => {
                      onBack()
                    }}
                  >
                    {pageText[42]}
                  </PaymentButton>
                  {loading ? (
                    <PaymentLoadingButton padding="11px 35px 11px 43px">
                      {pageText[6] + ' ' + pageText[7]}
                    </PaymentLoadingButton>
                  ) : (
                    <PaymentButton
                      padding="10px 30px"
                      onClick={() => {
                        handleSubmit()
                      }}
                    >
                      <img src="/images/icons/card.svg" />{' '}
                      {pageText[6] + ' ' + pageText[7]}
                    </PaymentButton>
                  )}

                  <PaymentButton
                    blackText
                    padding="11px 30px"
                    background="#FCBB32"
                    onClick={() => {
                      handleChooePaypal()
                    }}
                  >
                    {pageText[6] + ' by'}
                    <img src="/images/icons/paypal.svg" />
                  </PaymentButton>
                </FlexRowButtonsBottom>
              </PriceChoiceBox>

              {/* Trust & Security / ID */}
              <SafetySection>
                <FlexRowTrust gap="50px">
                  <SectionText>
                    <Title
                      color="#154549"
                      margin="0 0 20px 0"
                      size="22px"
                      sizemd="22px"
                      sizesm="26px"
                      dangerouslySetInnerHTML={{ __html: pageText[13] }}
                    />
                    <TrustSubtitle
                      bold
                      color="#154549"
                      weight="600"
                      size="20px"
                      sizesm="22px"
                      margin="0 0 5px 0"
                      dangerouslySetInnerHTML={{ __html: pageText[14] }}
                    />
                    <TrustParagraph
                      color="#154549"
                      weight="400"
                      margin="0 0 20px 0"
                      size="17px"
                      sizesm="20px"
                      dangerouslySetInnerHTML={{ __html: pageText[15] }}
                    />
                    <TrustSubtitle
                      bold
                      color="#154549"
                      weight="600"
                      size="20px"
                      sizesm="22px"
                      margin="0 0 5px 0"
                      dangerouslySetInnerHTML={{ __html: pageText[16] }}
                    />
                    <TrustParagraph
                      color="#154549"
                      weight="400"
                      margin="0 0 20px 0"
                      size="17px"
                      sizesm="20px"
                      dangerouslySetInnerHTML={{ __html: pageText[17] }}
                    />
                    <TrustSubtitle
                      bold
                      color="#154549"
                      weight="600"
                      size="20px"
                      sizesm="22px"
                      margin="0 0 5px 0"
                      dangerouslySetInnerHTML={{ __html: pageText[18] }}
                    />
                    <TrustParagraph
                      color="#154549"
                      weight="400"
                      margin="0 0 20px 0"
                      size="17px"
                      sizesm="20px"
                      dangerouslySetInnerHTML={{ __html: pageText[19] }}
                    />
                    <TrustParagraph
                      color="#154549"
                      weight="400"
                      margin="0 0 40px 0"
                      size="17px"
                      sizesm="20px"
                      dangerouslySetInnerHTML={{ __html: pageText[20] }}
                    />
                  </SectionText>
                  <CustomImageWrapper>
                    <CustomImage
                      imageBig={'/images/homepage-v2/marie-big.jpg'}
                      imageSmall={'/images/homepage-v2/marie-small.jpg'}
                      name={pageText2[43]}
                      text={pageText2[44]}
                      country={'Ireland'}
                      countryFlag={'ie'}
                    />
                  </CustomImageWrapper>
                </FlexRowTrust>
              </SafetySection>

              <Center>
                <img
                  src="/images/icons/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app2"
                />
                <img
                  src="/images/icons/licensePaypal-mobile.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app2"
                />
              </Center>
            </form>
          </ContainerBox>
        )}
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChoosePaymentOption))
